import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarGroupContainer = ({
  className,
  children,
  ...props
}) => /*#__PURE__*/_jsx("div", {
  className: className,
  ...props,
  children: children
});
export default ToolbarGroupContainer;